import React, { useState } from 'react'
import Grid from '@mui/material/Grid'
import Wrapper from './Wrapper'
import * as Icons from '../../../assets/Icons'
import { IconTab, Tabs } from '../../../assets/Buttons'
import matchConfig from '../../../config/matchConfig'
import { useTheme, useMediaQuery } from '@mui/material'

const MatchNav = props => {
    const [value, updateValue] = useState(props?.page || matchConfig.pages.profile)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const lang = props.lang.matchNav
    return (
        <Wrapper {...props} lang={lang}>
            <Grid item xs>
                <Grid
                    container
                    direction={"column"}
                    justifyContent={"center"}
                    rowSpacing={{ xs: 1, sm: 2, md: 2 }}
                >
                    <Grid item xs sx={{ maxWidth: '100%' }}>
                        {isMobile ? (
                            <Tabs
                                value={value}
                                onChange={(event, newValue) => {
                                    props.switchPage(newValue)
                                    updateValue(newValue)
                                }}
                                sx={{ mt: { xs: 1 } }}
                                indicatorColor="primary"
                                textColor="inherit"
                                variant="fullWidth"
                            >
                                <IconTab value={matchConfig.pages.profile} label="" icon={<Icons.ProfileCardIcon style={{ width: '100%' }} />} />
                                <IconTab value={matchConfig.pages.story} label="" icon={<Icons.StoryIcon style={{ width: '100%' }} />} />
                                <IconTab value={matchConfig.pages.chat} label="" icon={<Icons.MessengerIcon style={{ width: '100%' }} />} />
                            </Tabs>
                        ) : (
                            <Tabs
                                value={value}
                                onChange={(event, newValue) => {
                                    props.switchPage(newValue)
                                    updateValue(newValue)
                                }}
                                indicatorColor="primary"
                                textColor="inherit"
                                variant="fullWidth"
                            >
                                <IconTab value={matchConfig.pages.profile} label={lang.myBoard.toUpperCase()} icon={<Icons.ProfileCardIcon style={{ width: '100%' }} />} />
                                <IconTab value={matchConfig.pages.story} label={lang.stories.toUpperCase()} icon={<Icons.StoryIcon style={{ width: '100%' }} />} />
                                <IconTab value={matchConfig.pages.chat} label={lang.connect.toUpperCase()} icon={<Icons.MessengerIcon style={{ width: '100%' }} />} />
                            </Tabs>
                        )}
                    </Grid>

                    {props.children}
                </Grid>
            </Grid>
        </Wrapper>
    )
}

export default MatchNav